import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kt-block',
  templateUrl: './block.component.html',
  styleUrls: ['./block.component.scss']
})
export class BlockComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
